import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { dict, interpolate, LANGS } from "../i18n/translations";

const I18nCtx = createContext(null);
const KEY = "ipdfcv_lang";

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(KEY);
    if (saved && dict[saved]) return saved;
    const browser = (navigator.language || "en").slice(0, 2).toLowerCase();
    return dict[browser] ? browser : "en";
  });

  useEffect(() => {
    localStorage.setItem(KEY, lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = useCallback((key, vars) => {
    const val = dict[lang]?.[key] ?? dict.en[key] ?? key;
    return interpolate(val, vars);
  }, [lang]);

  const setLang = useCallback((l) => {
    if (dict[l]) setLangState(l);
  }, []);

  return (
    <I18nCtx.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </I18nCtx.Provider>
  );
}

export function useI18n() {
  return useContext(I18nCtx);
}
export function useT() {
  return useContext(I18nCtx).t;
}
